import type { EventCategory } from './base';

export const EmployeeEvents = {
  EMPLOYEE_INVITED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string | undefined,
      employeeId: '' as string | undefined,
      roleName: '' as string,
      companyId: '' as string | undefined,
      canteenId: '' as string | undefined,
      language: '' as string | undefined,
      hasPassword: false as boolean,
      inviteId: '' as string,
    },
  },
  EMPLOYEE_PROFILE_UPDATED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string | undefined,
      employeeId: '' as string,
      roleNames: [] as string[],
      companyId: '' as string | undefined,
      canteenId: '' as string | undefined,
      language: '' as string | undefined,
      status: '' as string,
    },
  },
  EMPLOYEE_DEACTIVATED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string | undefined,
      employeeId: '' as string,
      companyId: '' as string | undefined,
      canteenId: '' as string | undefined,
      reason: '' as string,
      initiatorRole: '' as string,
    },
  },
  DIETARY_PREFERENCE_UPDATED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      subjectType: '' as string,
      subjectId: '' as string,
      dietaryCode: '' as string | undefined,
      source: '' as string,
      changedByRole: '' as string,
      notes: '' as string | undefined,
    },
  },
  ATTENDANCE_PATTERN_SAVED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string | undefined,
      authUserId: '' as string,
      weekdayCount: 0 as number,
      autoGenerated: false as boolean,
      changedByRole: '' as string,
    },
  },
} as const;
